import React from "react";
import { AlertCircle } from "lucide-react";

export const Chat8PerguntasPanelEmptyState: React.FC = React.memo(() => {
  return (
    <div
      id="chat8-perguntas-content"
      className="chat8-perguntas-content"
      data-testid="chat8-perguntas-content"
      style={{
        flex: 1,
        overflow: "auto",
        padding: "16px",
      }}
    >
      <div className="flex flex-col items-center justify-center h-full text-center text-gray-400">
        <AlertCircle className="h-10 w-10 mb-4" />
        <p className="text-lg font-medium">Aguardando Perguntas</p>
        <p className="text-sm">
          Quando o assistente enviar perguntas, elas aparecerão aqui.
        </p>
      </div>
    </div>
  );
});

Chat8PerguntasPanelEmptyState.displayName = "Chat8PerguntasPanelEmptyState"; 